<!-- 企业合伙人 -->
<template>
  <div class="frame">
    <img
      src="http://api.zyzxgc.cn/file/static/banner_team.jpg"
      class="banner"
    />
    <div class="wrap">
      <div class="breadcrumb w1200">
        <bread-crumb :breadcrumbs="routerHistory"></bread-crumb>
      </div>
      <sub-nav :subNavs="subNavs"></sub-nav>
      <div class="container w1200">
        <sub-title title="企业合伙人" en="BUSINSS PARTNER"></sub-title>
        <div class="desc">
          一段关于企业合伙人的简单介绍一段关于企业合伙人的简单介绍一段关于企业合伙人的简单介绍一段关于企业合伙人的简单介绍一段关于企业合伙人的简单介绍一段关于企业合伙人的简单介绍一段关于企业合伙人的简单介绍一段关于企业合伙人的简单介绍一段关于企业合伙人的简单介绍一段关于企业合伙人的简单介绍一段关于企业合伙人的简单介绍一段关于企业合伙人的简单介绍......
        </div>
        <div class="form">
          <el-form
            ref="form"
            :model="addParams"
            :rules="addRules"
            label-width="80px"
          >
            <el-form-item label="您的姓名" prop="userName">
              <el-input v-model="addParams.userName"></el-input>
            </el-form-item>
            <el-form-item label="您的电话" prop="phone">
              <el-input v-model="addParams.phone"></el-input>
            </el-form-item>
            <el-form-item label="您的邮箱" prop="email">
              <el-input v-model="addParams.email"></el-input>
            </el-form-item>
            <el-form-item label="您的留言" prop="content">
              <el-input
                type="textarea"
                rows="4"
                v-model="addParams.content"
              ></el-input>
            </el-form-item>
          </el-form>
          <div style="text-align: center">
            <el-button class="btn" type="primary" @click="submit"
              >提交</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Store } from "@/store/index.js";
import { mapState } from "pinia";
import breadCrumb from "@/components/breadCrumb.vue";
import SubNav from "@/components/subNav.vue";
import SubTitle from "@/components/subTitle.vue";
export default {
  components: { breadCrumb, SubNav, SubTitle },
  data() {
    return {
      routerHistory: [], // 当前所在位置
      subNavs: [],
      addParams: {
        userName: "",
        phone: "",
        email: "",
        content: "",
        type: 3,
      },
      addRules: {
        userName: { required: true, message: "请输入姓名" },
        phone: { required: true, message: "请输入电话" },
        email: { required: true, message: "请输入邮箱" },
        content: { required: true, message: "请输入留言内容" },
      },
    };
  },
  computed: {
    ...mapState(Store, ["navList"]),
  },
  created() {
    this.formatBreadCrumb();
  },
  mounted() {},
  methods: {
    // 格式化导航条和二级导航栏
    formatBreadCrumb() {
      let nav = this.navList.find(
        (ele) => ele.path != "/" && this.$route.path.includes(ele.path)
      );
      if (nav.subs && nav.subs.length != 0) {
        // 二级导航栏
        this.subNavs = nav.subs;
      }
      this.routerHistory = [{ path: "/", name: "首页" }, nav];
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$api.addFeedback(this.addParams).then((res) => {
            if (res.code == 0) {
              this.$notify.success({
                title: "提示",
                message: "留言提交成功！我们将在收到消息后会尽快与您联系！",
              });
              this.$refs.form.resetFields();
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.frame {
  .banner {
    width: 100%;
    display: block;
  }
  .wrap {
    &::before,
    &::after {
      content: "";
      display: table;
    }
  }
  .breadcrumb {
    margin: 25px auto 20px;
  }
  .container {
    margin: 70px auto 30px;

    .desc {
      width: 1040px;
      margin: 50px auto 70px;
      font-size: 15px;
      color: #5e5d5d;
    }
    .form {
      width: 750px;
      margin: 0 auto 120px;
    }
    .btn {
      width: 150px;
    }
  }
}

@media (max-width: 750px) {
  .frame {
    .banner {
      height: auto;
    }
    .breadcrumb {
      display: none;
    }
    .container {
      margin: 20px 0;
      padding: 0 10px;
      box-sizing: border-box;

      .desc {
        width: 100%;
        margin: 20px 0;
        font-size: 14px;
        line-height: 1.8;
      }
      .form {
        width: 100%;
        margin-bottom: 30px;
      }
    }
  }
}
</style>
